import { render } from "./useraccounts.vue?vue&type=template&id=136e4169"
import script from "./useraccounts.vue?vue&type=script&lang=js"
export * from "./useraccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__